import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';

const CustomCarousel = ({
  children,
  autoPlay = true,
  interval = 5000,
  showControls = true,
  showIndicators = true,
  sx
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = React.Children.count(children);

  useEffect(() => {
    if (!autoPlay) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, interval);
    return () => clearInterval(timer);
  }, [currentIndex, autoPlay, interval, totalSlides]);

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % totalSlides);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  const goToSlide = (index) => setCurrentIndex(index);

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden', ...sx }}>
      {/* Slides Container */}
      <Box
        sx={{
          display: 'flex',
          // width: `${totalSlides * 100}%`,
          transform: `translateX(-${currentIndex * 100}%)`,
          // transition: 'transform 0.6s ease-in-out',
        }}
      >
        {React.Children.map(children, (child, index) => (
          <Box
            key={index}
            sx={{
              width: '100%',
              height: '100vh',
              flexShrink: 0,
              position: 'relative',
            }}
          >
            {child}
          </Box>
        ))}
      </Box>

      {/* Optional Prev / Next Buttons */}
      {showControls && (
        <>
          <Button
            onClick={prevSlide}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '1rem',
              transform: 'translateY(-50%)',
              color: 'white',
              zIndex: 10,
              fontSize: '2rem',
            }}
          >
            ‹
          </Button>
          <Button
            onClick={nextSlide}
            sx={{
              position: 'absolute',
              top: '50%',
              right: '1rem',
              transform: 'translateY(-50%)',
              color: 'white',
              zIndex: 10,
              fontSize: '2rem',
            }}
          >
            ›
          </Button>
        </>
      )}

      {/* Optional Indicators */}
      {showIndicators && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '1rem',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '0.5rem',
            zIndex: 10,
          }}
        >
          {Array.from({ length: totalSlides }).map((_, i) => (
            <Box
              key={i}
              onClick={() => goToSlide(i)}
              sx={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: i === currentIndex ? '#fff' : '#888',
                cursor: 'pointer',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CustomCarousel;

